export default class LessonRegistrationForm {
    constructor($form) {
        this.$form = $form;
        this.$childSelect = $form.querySelector('[data-registration-child-select]');
        this.$childFields = {
            firstName: $form.querySelector('[data-registration-child-field="firstName"]'),
            lastName: $form.querySelector('[data-registration-child-field="lastName"]'),
            birthday: $form.querySelector('[data-registration-child-field="birthday"]'),
        };
        this.$phoneFields = $form.querySelectorAll('[data-registration-phone]');
        this.$accountToggle = $form.querySelector('[data-registration-account-toggle]');
        this.$accountFields = $form.querySelector('[data-registration-account-fields]');
        this.$accountRequiredFields = this.$accountFields
            ? this.$accountFields.querySelectorAll('[data-registration-account-required]')
            : [];

        this.$phoneFields.forEach(($field) => {
            $field.addEventListener('input', () => this.validatePhoneField($field));
            $field.addEventListener('blur', () => this.validatePhoneField($field));
            $field.addEventListener('invalid', () => this.validatePhoneField($field));
        });
        this.$form.addEventListener('submit', (event) => this.validateBeforeSubmit(event));

        if (this.$accountToggle && this.$accountFields) {
            this.$accountToggle.addEventListener('change', () => this.toggleAccountFields());
            this.toggleAccountFields();
        }

        if (!this.$childSelect) {
            return;
        }

        this.$childSelect.addEventListener('change', () => this.applyChildSelection());
        this.applyChildSelection();
    }

    toggleAccountFields() {
        const enabled = this.$accountToggle.checked;
        this.$accountFields.hidden = !enabled;

        this.$accountRequiredFields.forEach(($field) => {
            $field.required = enabled;
            if (!enabled) {
                $field.value = '';
            }
        });
    }

    validateBeforeSubmit(event) {
        const $invalidPhone = Array.from(this.$phoneFields).find(($field) => !this.validatePhoneField($field));

        if (!$invalidPhone) {
            return;
        }

        event.preventDefault();
        $invalidPhone.reportValidity();
        $invalidPhone.focus();
    }

    validatePhoneField($field) {
        $field.setCustomValidity('');

        if ($field.value.trim() === '') {
            return !$field.required;
        }

        if (this.isValidPhoneNumber($field.value)) {
            return true;
        }

        $field.setCustomValidity($field.dataset.registrationPhoneMessage || 'Gelieve een geldig telefoonnummer in te geven.');
        return false;
    }

    isValidPhoneNumber(value) {
        const cleaned = this.cleanPhoneNumber(value);

        return /^0\d{8,9}$/.test(cleaned)
            || /^\+[1-9]\d{7,14}$/.test(cleaned)
            || /^00[1-9]\d{7,14}$/.test(cleaned);
    }

    cleanPhoneNumber(value) {
        const normalized = value
            .trim()
            .replace(/[\u00A0\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '');

        if (normalized.charAt(0) === '+') {
            return `+${normalized.substring(1).replace(/[^\d]+/g, '')}`;
        }

        return normalized.replace(/[^\d]+/g, '');
    }

    applyChildSelection() {
        const $option = this.$childSelect.selectedOptions[0] || null;
        const hasChild = $option !== null && this.$childSelect.value !== '';

        this.setField('firstName', hasChild ? ($option.dataset.firstName || '') : '', hasChild);
        this.setField('lastName', hasChild ? ($option.dataset.lastName || '') : '', hasChild);
        this.setField('birthday', hasChild ? ($option.dataset.birthday || '') : '', false);
    }

    setField(name, value, isReadOnly) {
        const $field = this.$childFields[name];
        if (!$field) {
            return;
        }

        $field.value = value;
        $field.readOnly = isReadOnly;
        $field.required = true;
    }
}
